import React, {Fragment, useEffect, useState} from "react";
import queryString from 'query-string'
import {useLocation} from 'react-router-dom'

import './OrgDashboardTab.scss';
import DashboardPanelOrgChildAge from "root/dashboard/DashboardPanelOrgChildAge";
import DashboardPanelOrgLogins from "root/dashboard/DashboardPanelOrgLogins";
import DashboardPanelOrgChildrenDiary from "root/dashboard/DashboardPanelOrgChildrenDiary";
import DashboardPanelOrgPosts from "root/dashboard/DashboardPanelOrgPosts";
import {UserTypes} from "root/DataFunctions/Constants";
import {getMonthName} from "root/DataFunctions/DashboardDataFns"
import DashboardPanelOrgUsers from "root/dashboard/DashboardPanelOrgUsers";
import DashboardPanelOrgMessages from "root/dashboard/DashboardPanelOrgMessages";
import phpVars from 'phpVars';
import DashboardPanelTeamPosts from "root/dashboard/DashboardPanelTeamPosts";
import DashboardPanelTeamMessages from "root/dashboard/DashboardPanelTeamMessages";

const OrgDashboardTab = (props) =>
{
    const d = new Date();
    const currentMonth = d.getMonth();
    const currentYear = d.getFullYear();

    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);

    const {search} = useLocation()

    const queryParams = queryString.parse(search);

    const displayPanel = () =>
    {
        const has_lifestory = phpVars.has_lifestory === 1 ? true :false;

        switch (queryParams.type)
        {
            case 'child-posts':
                return <DashboardPanelOrgPosts user_type={UserTypes.CHILD} title={'Child Posts'} year={year} month={month+1}/>
                break;

            case 'child-messages':
                return <DashboardPanelOrgMessages user_type={UserTypes.CHILD} title={'Child Messages'} year={year} month={month+1}/>
                break;

            case 'staff-messages':
                return <DashboardPanelOrgMessages user_type={null} title={'Staff Messages'} year={year} month={month+1}/>
                break;

            case 'all-messages':
                return <DashboardPanelOrgMessages user_type={UserTypes.ALL} title={'All Messages'} year={year} month={month+1}/>
                break;

            case 'child-logins':
                return <DashboardPanelOrgLogins user_type={UserTypes.CHILD} title={'Child Logins'} year={year} month={month+1}/>
                break;

            case 'child-diary':
                return <DashboardPanelOrgChildrenDiary title={'Child Diary Entries'} year={year} month={month+1}/>
                break;

            case 'staff-logins':
                return <DashboardPanelOrgLogins user_type={null} title={'Staff Logins'} year={year} month={month+1}/>
                break;

            case 'all-logins':
                return <DashboardPanelOrgLogins user_type={UserTypes.ALL} title={'All Logins'} year={year} month={month+1}/>
                break;

            case 'staff-posts':
                return <DashboardPanelOrgPosts user_type={null} title={'Staff Posts'} year={year} month={month+1}/>
                break;

            case 'all-posts':
                return <DashboardPanelOrgPosts user_type={UserTypes.ALL} title={'All Posts'} year={year} month={month+1}/>
                break;

            case 'child-age':
                return <DashboardPanelOrgChildAge title={'Number of Children In Age Range'}/>
                break;

            case 'users':
                return <DashboardPanelOrgUsers title={'Users by Type'} team_id={'all'} />
                break;

            default:
                if(has_lifestory){
                    return <DashboardPanelOrgPosts user_type={UserTypes.CHILD} title={'Child Posts'} year={year} month={month+1}/>
                }
                else{
                    return <DashboardPanelOrgMessages user_type={UserTypes.CHILD} title={'Child Messages'} year={year} month={month+1}/>
                }

                break;
        }
    }

    const onClickPrevious = () =>
    {
        if(month == 0){
            setMonth(11);
            setYear(curYear=> curYear - 1);
        }
        else{
            setMonth(curMonth=> curMonth - 1);
        }
    }

    const onClickNext = () =>
    {
        if(month == 11){
            setMonth(0);
            setYear(curYear=> curYear + 1);
        }
        else{
            setMonth(curMonth=> curMonth + 1);
        }
    }

    const displayDateString = () =>{
        let monthName = getMonthName(month);
        let monthString = monthName + ' ' + year;
        return <div>{monthString}</div>
    }

    return (
        <Fragment>
            <div className="family-body">
                {displayPanel()}
            </div>

            {/* Month Buttons*/}
            {(queryParams.type !== 'child-age' && queryParams.type !== 'users') &&
                <div className="d-flex flex-row justify-content-end">
                    <div className="family-body">
                        {displayDateString()}
                    </div>

                    <div className="p-2">
                        <button onClick={onClickPrevious} className="btn btn-primary">-<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                    <div className="p-2">
                        <button onClick={onClickNext} className="btn btn-primary">+<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                </div>
            }
        </Fragment>
    )
}

OrgDashboardTab.defaultProps = {};

export default OrgDashboardTab;


